import 'simplebar/src/simplebar.css';
import React from 'react';
import App from './App.jsx';

import { store } from './store/index.js';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

let persistor = persistStore(store);
const container = document.getElementById('root');
const root = createRoot(container);

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  const originalWarn = console.warn;
  // eslint-disable-next-line no-console
  console.warn = (...args) => {
    // Filter out specific Material-UI warnings
    if (args[0].includes('MUI: The value provided to Autocomplete is invalid.')) {
      return;
    }
    // Keep other warnings
    originalWarn(...args);
  };
}

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </HelmetProvider>
);
